/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './implant-order.reducer';

export const ImplantOrderDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const implantOrderEntity = useAppSelector(state => state.implantOrder.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="implantOrderDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.implantOrder.detail.title">ImplantOrder</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.implantOrder.id">Id</Translate>
            </span>
          </dt>
          <dd>{implantOrderEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.implantOrder.active">Active</Translate>
            </span>
          </dt>
          <dd>{implantOrderEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.implantOrder.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{implantOrderEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.implantOrder.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{implantOrderEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.implantOrder.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{implantOrderEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.implantOrder.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{implantOrderEntity.cursor}</dd>
          <dt>
            <span id="patientType">
              <Translate contentKey="tinyMedicRestApp.implantOrder.patientType">Patient Type</Translate>
            </span>
          </dt>
          <dd>{implantOrderEntity.patientType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.implantOrder.admission">Admission</Translate>
          </dt>
          <dd>{implantOrderEntity.admission ? implantOrderEntity.admission.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.implantOrder.orderedBy">Ordered By</Translate>
          </dt>
          <dd>{implantOrderEntity.orderedBy ? implantOrderEntity.orderedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.implantOrder.prescription">Prescription</Translate>
          </dt>
          <dd>{implantOrderEntity.prescription ? implantOrderEntity.prescription.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/implant-order" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/implant-order/${implantOrderEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ImplantOrderDetail;
